"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DominateYourLocalMarket() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const annotations = [{
    label: "WEB DESIGN",
    meta: "CUSTOM"
  }, {
    label: "SEO STRATEGY",
    meta: "GROWTH"
  }, {
    label: "LOCAL SEO",
    meta: "LISTINGS"
  }];
  return;
}